import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './components/Landing';
import Organizers from "./components/Organizers";
import Home from './components/Home';
import Events from './components/events/Events';
import EventDetails from './components/events/EventDetails';
import GuestUpload from './components/events/GuestUpload';
import ProjectionScreen from './components/events/ProjectionScreen';
import LiveAccessScreen from './components/events/LiveAccessScreen';
import LiveMatchAccessScreen from './components/admin/LiveMatchAccessScreen';
import MobileBroadcaster from './components/events/MobileBroadcaster';
import Profile from './components/pages/Profile';
import ProtectedRoute from './components/pages/ProtectedRoute';
import AdminEmployees from './components/employes/AdminEmployees';
import AdminExpenses from './components/admin/AdminExpenses';
import AdminEvents from './components/events/AdminEvents';
import EventPhotosModeration from './components/events/EventPhotosModeration';
import AdminTournaments from './components/admin/AdminTournaments';
import AdminMatches from './components/admin/AdminMatches';
import CreateTournament from './components/admin/CreateTournament';
import EditTournament from './components/admin/EditTournament';
import AdminTournamentTeams from './components/admin/AdminTournamentTeams';
import AdminTournamentFixture from './components/admin/AdminTournamentFixture';
import TournamentDetails from './components/landing/TournamentDetails';
import MyTeam from './components/landing/MyTeam';
import EditEvent from './components/events/EditEvent';
import CreateEvent from './components/events/CreateEvent';
import AdminTickets from './components/pages/AdminTickets';
import AdminRrpp from './components/admin/AdminRrpp';
import RrppDashboard from './components/pages/RrppDashboard';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminAgenda from './components/admin/AdminAgenda';
import ConfirmacionPago from './components/pages/confirmacion-pago';
import QuoteEventForm from './components/pages/QuoteEventForm';
import AdminQuoteRequests from './components/admin/AdminQuoteRequests';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/layout/ScrollToTop';
import AdminGallery from './components/pages/AdminGallery';
import Settings from './components/admin/Settings';
import StaffManagement from './components/admin/StaffManagement';
import SupportSection from './components/pages/SupportSection';
import SalonSupportSection from './components/pages/SalonSupportSection';
import SuperAdminDashboard from './components/superadmin/SuperAdminDashboard';
import PointOfSale from './components/pos/PointOfSale';
import AdminBarCatalog from './components/admin/AdminBarCatalog';
import EventBarDashboard from './components/admin/EventBarDashboard';
import AdminBilling from './components/admin/AdminBilling'; // NEW ARRIVAL
import ExploreSalons from './components/pages/ExploreSalons';
import { useDispatch } from 'react-redux';
import { loadUser } from './store/slices/authSlice';
import { useEffect } from 'react';
import './index.css';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/*
          1) Ruta raíz “/”: muestra la Landing de bienvenida
        */}
        <Route path="/" element={<Organizers />} />
        <Route path="/productores" element={<Navigate to="/" replace />} />
        <Route path="/eventos" element={<Landing />} />
        <Route path="/explorar" element={<ExploreSalons />} />
        <Route path="/suport" element={<SupportSection />} />

        {/*
          2) A partir de aquí, todas las demás rutas “públicas” o “protegidas”
             estarán bajo el slug dinámico `/:slug`. Ejemplo:
             - "/salon-lux"
             - "/salon-lux/events"
             - "/salon-lux/events/123"
             etc.
        */}
        <Route path="/:slug" element={<Layout />}>

          <Route index element={<Home />} />


          <Route path="events" element={<Events />} />
          <Route path="events/:id" element={<EventDetails />} />
          <Route path="events/:id/upload" element={<GuestUpload />} />
          <Route path="events/:id/projection" element={<ProjectionScreen />} />
          <Route path="events/:id/broadcaster" element={<MobileBroadcaster />} />
          <Route path="events/:id/live-access" element={<LiveAccessScreen />} />
          <Route
            path="matches/:id/live-access"
            element={
              <ProtectedRoute requiredPermission="escanear_tickets">
                <LiveMatchAccessScreen />
              </ProtectedRoute>
            }
          />
          <Route path="tournaments/:id" element={<TournamentDetails />} />
          <Route path="confirmacion-pago" element={<ConfirmacionPago />} />
          <Route path="quote" element={<QuoteEventForm />} />
          <Route path="support" element={< SalonSupportSection />} />

          {/* Rutas protegidas para usuarios loggeados */}
          <Route
            path="profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="tournaments/:id/my-team/:teamId?"
            element={
              <ProtectedRoute>
                <MyTeam />
              </ProtectedRoute>
            }
          />

          {/* Rutas solo para admin del salón */}
          <Route
            path="admin/dashboard"
            element={
              <ProtectedRoute requiredPermission="ver_estadisticas">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/employees"
            element={
              <ProtectedRoute adminOnly>
                <AdminEmployees />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/expenses/:eventId"
            element={
              <ProtectedRoute adminOnly>
                <AdminExpenses />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/events/create"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <CreateEvent />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/events"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/agenda"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminAgenda />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/quotes"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminQuoteRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/events/:eventId/photos"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <EventPhotosModeration />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/tournaments"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminTournaments />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/tournaments/create"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <CreateTournament />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/tournaments/edit/:id"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <EditTournament />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/tournaments/:id/teams"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminTournamentTeams />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/tournaments/:id/fixture"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminTournamentFixture />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/matches"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminMatches />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/live-access"
            element={
              <ProtectedRoute requiredPermission="escanear_tickets">
                <AdminMatches />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/events/edit/:id"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <EditEvent />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/tickets"
            element={
              <ProtectedRoute requiredPermission="escanear_tickets">
                <AdminTickets />
              </ProtectedRoute>
            }
          />

          {/* ✅ AÑADIR ACÁ LA RUTA DE GALLERY */}
          <Route
            path="admin/gallery"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminGallery />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/bar-catalog"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <AdminBarCatalog />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/events/:eventId/bar"
            element={
              <ProtectedRoute requiredPermission="gestionar_eventos">
                <EventBarDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/events/:eventId/pos"
            element={
              <ProtectedRoute cashierOnly>
                <PointOfSale />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/rrpp"
            element={
              <ProtectedRoute adminOnly>
                <AdminRrpp />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/staff"
            element={
              <ProtectedRoute requiredPermission="gestionar_staff">
                <StaffManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/billing"
            element={
              <ProtectedRoute adminOnly>
                <AdminBilling />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/settings"
            element={
              <ProtectedRoute adminOnly>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="rrpp/dashboard"
            element={
              <ProtectedRoute>
                <RrppDashboard />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Ruta Global de SuperAdmin (fuera del contexto de salón si se prefiere, o dentro) */}
        <Route
          path="/superadmin/dashboard"
          element={
            <ProtectedRoute superAdminOnly>
              <SuperAdminDashboard />
            </ProtectedRoute>
          }
        />

        {/*
          3) Cualquier otra ruta no definida (404), podrías:
             – mostrar un componente <NotFound />
             – o redirigir a “/”
        */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
